const DAY_MILLISECONDS = 864e5;

export function parseDate(val): Date {
  if (val) {
    return new Date(val);
  } else {
    return undefined;
  }
}

export function isTodayInBrazil(date: Date): boolean {
  const today = new Date();
  return isSameDayInTimezone(today, date, -180);
}

export function isSameDayInTimezone(first: Date, second: Date, timezoneInMinutes: number): boolean {
  const firstDateInTimezone = applyTimezone(first, timezoneInMinutes);
  const firstDayInTimezone = firstDateInTimezone.getDate();
  const secondDateInTimezone = applyTimezone(second, timezoneInMinutes);
  const secondDayInTimezone = secondDateInTimezone.getDate();
  return firstDayInTimezone === secondDayInTimezone;
}

export function applyTimezone(date: Date, timezoneInMinutes: number): Date {
  if (date) {
    const mutableDate = new Date(date);
    const offset = date.getTimezoneOffset();
    mutableDate.setMinutes(mutableDate.getMinutes() + offset);
    mutableDate.setMinutes(mutableDate.getMinutes() + timezoneInMinutes);
    return mutableDate;
  } else {
    return undefined;
  }
}

export function calcDaysOfLife(date): number {
  if (date) {
    const today = Date.now();
    const millisecondsOfLife = today - date.getTime();
    const floating = millisecondsOfLife % DAY_MILLISECONDS;
    const daysOfLife = (millisecondsOfLife - floating) / DAY_MILLISECONDS;
    return daysOfLife;
  } else {
    return undefined;
  }
}

export function getDateOnly(date): string {
  if (date) {
    return date.toJSON().substring(0, 10);
  } else {
    return undefined;
  }
}
